<template>
  <ag-input :id="id" :value="inputValue" @change="inputValue = $event" />
</template>

<script>
  import Cleave from "cleave.js";

  export default {
    name: "PhoneInput",
    mounted() {
      new Cleave(this.$el, {
        blocks: [0, 3, 3, 4],
        delimiters: ["(", ") ", "-"],
        numericOnly: true
      });
    },
    props: {
      id: String,
      type: String,
      value: String
    },
    computed: {
      inputValue: {
        get() {
          return this.value;
        },
        set(value) {
          let numbersOnly = value.replace(/\D/g, "");
          if (numbersOnly && numbersOnly.length > 10) {
            numbersOnly = numbersOnly.slice(0, 10);
          }
          this.$emit("change", numbersOnly);
        }
      }
    }
  };
</script>
